/* eslint-disable react/destructuring-assignment */
import React from 'react';
import NameCell from './components/NameCell';
import GenericCell from './components/GenericCell';
import TagCell from './components/TagCell';
import { CheckColum } from './components/CheckColumn/CheckColum';
import { CheckHeader } from './components/CheckHeader/CheckHeader';

const minWidthClassName = (className, fieldKey) => (rowInfo, { fields }) => ({
  className: `${className} min-wd-${fields[fieldKey]?.defaultWidth}`
});

/**
 * Services table (workspace Services screen).
 * ctx: `{ fields, isFetching }`
 */
const servicesSchema = {
  id: 'services',
  ordering: {},
  columns: [
    {
      header: () => <CheckHeader />,
      accessor: 'selected',
      id: 'Selected',
      maxWidth: 38,
      minWidth: 38,
      resizable: false,
      sortable: false,
      visible: true,
      cell: (rowInfo, { isFetching }) => <CheckColum service={ rowInfo.original } showSkeleton={ isFetching } />,
      order: -1
    },
    {
      accessor: 'name',
      id: 'name',
      header: () => <div>NAME</div>,
      cell: (rowInfo, { isFetching }) => <NameCell rowInfo={ rowInfo.original } showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.name?.visible,
      maxWidth: ({ fields }) => fields.name?.maxWidth,
      minWidth: ({ fields }) => fields.name?.minWidth,
      order: ({ fields }) => fields.name?.order,
      cellProps: minWidthClassName('name', 'name')
    },
    {
      accessor: 'version',
      id: 'version',
      header: () => <div>VERSION</div>,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo.original } attrib="version" showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.version?.visible,
      maxWidth: ({ fields }) => fields.version?.maxWidth,
      minWidth: ({ fields }) => fields.version?.minWidth,
      order: ({ fields }) => fields.version?.order,
      cellProps: minWidthClassName('version', 'version')
    },
    {
      accessor: 'port',
      id: 'port',
      header: () => <div>PORT</div>,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo.original } attrib="port" showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.port?.visible,
      maxWidth: ({ fields }) => fields.port?.maxWidth,
      minWidth: ({ fields }) => fields.port?.minWidth,
      order: ({ fields }) => fields.port?.order,
      cellProps: minWidthClassName('port', 'port')
    },
    {
      accessor: 'protocol',
      id: 'protocol',
      header: () => <div>PROTOCOL</div>,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo.original } capitalize="uppercase" attrib="protocol" showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.protocol?.visible,
      maxWidth: ({ fields }) => fields.protocol?.maxWidth,
      minWidth: ({ fields }) => fields.protocol?.minWidth,
      order: ({ fields }) => fields.protocol?.order,
      cellProps: minWidthClassName('protocol', 'protocol')
    },
    {
      accessor: 'status',
      id: 'status',
      header: () => <div>STATUS</div>,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo.original } attrib="status" showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.status?.visible,
      maxWidth: ({ fields }) => fields.status?.maxWidth,
      minWidth: ({ fields }) => fields.status?.minWidth,
      order: ({ fields }) => fields.status?.order,
      cellProps: minWidthClassName('status', 'status')
    },
    {
      accessor: 'vulns',
      id: 'vulnerability_count',
      header: () => <div>VULNERABILITIES</div>,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo.original } attrib="vulns" showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.vulns?.visible,
      maxWidth: ({ fields }) => fields.vulns?.maxWidth,
      minWidth: ({ fields }) => fields.vulns?.minWidth,
      order: ({ fields }) => fields.vulns?.order,
      cellProps: minWidthClassName('vulns', 'vulns')
    },
    {
      accessor: 'owned',
      id: 'owned',
      header: () => <div>OWNED</div>,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo.original } attrib="owned" showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.owned?.visible,
      maxWidth: ({ fields }) => fields.owned?.maxWidth,
      minWidth: ({ fields }) => fields.owned?.minWidth,
      order: ({ fields }) => fields.owned?.order,
      cellProps: minWidthClassName('owned', 'owned')
    },
    {
      accessor: 'parent_name',
      id: 'host__ip',
      header: () => <div>ASSET</div>,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo.original } attrib="parent_name" showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.asset?.visible,
      maxWidth: ({ fields }) => fields.asset?.maxWidth,
      minWidth: ({ fields }) => fields.asset?.minWidth,
      order: ({ fields }) => fields.asset?.order,
      cellProps: minWidthClassName('parent_name', 'asset')
    },
    {
      accessor: 'tags',
      id: 'tags',
      header: () => <div>TAGS</div>,
      cell: (rowInfo, { isFetching }) => <TagCell rowInfo={ rowInfo.original } showSkeleton={ isFetching } />,
      resizable: true,
      sortable: false,
      visible: ({ fields, isTagsAllowedByLicense }) => fields.tags?.visible && isTagsAllowedByLicense,
      order: ({ fields }) => fields.tags?.order,
      maxWidth: ({ fields }) => fields.tags?.maxWidth,
      minWidth: ({ fields }) => fields.tags?.minWidth,
      cellProps: minWidthClassName('tags', 'tags')
    },
    {
      accessor: 'description',
      id: 'description',
      header: () => <div>DESCRIPTION</div>,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo.original } attrib="description" showSkeleton={ isFetching } />,
      resizable: true,
      sortable: true,
      visible: ({ fields }) => fields.description?.visible,
      maxWidth: ({ fields }) => fields.description?.maxWidth,
      minWidth: ({ fields }) => fields.description?.minWidth,
      order: ({ fields }) => fields.description?.order,
      cellProps: (rowInfo, { fields }) => ({ className: `min-wd-${fields.description?.defaultWidth}` })
    }
  ]
};

export default servicesSchema;
